import React from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { DrawerLayoutWrapper } from 'common';
import ProgressBar from 'feature/dispatching/components/ProgressBar';
import CompartmentsForm from '../components/CompartmentsForm';

const Compartments = ({ onClose, next, prev, trailerState, setTrailerState }) => {
  const { compartments } = trailerState;

  const isInvalid = R.anyPass([
    R.o(R.gt(1), R.prop('compartments')),
    R.compose(
      R.any(R.equals('')),
      R.map(R.prop('capacityInGallons')),
      R.defaultTo([]),
      R.prop('compartments')
    ),
    R.compose(
      R.any(R.gt(1)),
      R.map(R.prop('capacityInGallons')),
      R.defaultTo([]),
      R.prop('compartments')
    ),
  ])(trailerState);

  const handleAdd = () => {
    const lens = R.lensProp('compartments');
    setTrailerState(trailer => {
      return R.over(
        lens,
        R.append({
          capacityInGallons: ' ',
          position: R.inc(trailer.compartments.length),
        }),
        trailer
      );
    });
  };

  const handleUpdate = (index, value) => {
    const path = ['compartments', index, 'capacityInGallons'];
    setTrailerState(R.set(R.lensPath(path), value));
  };

  const handleRemove = index => {
    const lens = R.lensProp('compartments');
    const mapIndexed = R.addIndex(R.map);
    const reposition = mapIndexed((c, i) => ({
      ...c,
      position: R.inc(i),
    }));
    const update = R.o(reposition, R.remove(index, 1));
    setTrailerState(R.over(lens, update));
  };

  const buttons = (
    <Box sx={{ display: 'flex', justifyContent: 'space-around', width: 1 }}>
      <Button onClick={prev} sx={{ width: 150 }} variant="outlined">
        Back
      </Button>
      <Button disabled={isInvalid} onClick={next} sx={{ width: 150 }}>
        Continue
      </Button>
    </Box>
  );

  return (
    <DrawerLayoutWrapper
      buttons={buttons}
      headerButtonText="CLOSE"
      onHeaderButtonClick={onClose}
      title="New Trailer"
    >
      <ProgressBar
        label="Compartments (3 of 5)"
        sx={{
          '&.MuiLinearProgress-colorPrimary > .MuiLinearProgress-bar': {
            borderRadius: '10px',
          },
        }}
        value={60}
      />
      <Stack sx={{ ml: 3, mr: 2, mt: 3 }}>
        <CompartmentsForm
          compartments={compartments}
          onAddCompartment={handleAdd}
          onRemoveCompartment={handleRemove}
          onUpdateCompartment={handleUpdate}
          title="Configure Trailer Compartments"
        />
      </Stack>
    </DrawerLayoutWrapper>
  );
};

Compartments.propTypes = {
  next: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  prev: PropTypes.func.isRequired,
  setTrailerState: PropTypes.func.isRequired,
  trailerState: PropTypes.shape({
    compartments: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
};

export default Compartments;
